import { useFeatureFlags } from 'hooks/useFeatureFlags'

import { InputSelectControl } from '@sequencehq/core-components'

import {
  RevenueClassification,
  revenueClassificationOptions
} from 'common/types/revenueRecognition.types'
import { FieldLabel } from '../layout/FieldLabel'

type Props = {
  revenueClassification: RevenueClassification | undefined
  setRevenueClassification: (classification: RevenueClassification) => void
}

export const RevenueClassificationField = ({
  revenueClassification,
  setRevenueClassification
}: Props) => {
  const flags = useFeatureFlags()

  if (!flags.useRevRec) return null

  return (
    <FieldLabel label="Revenue classification">
      <InputSelectControl
        options={revenueClassificationOptions}
        placeholder="Select revenue classification"
        initialValue={revenueClassification}
        onChange={newValue =>
          setRevenueClassification(newValue as RevenueClassification)
        }
      />
    </FieldLabel>
  )
}
